import naturalSortComparator from '_legacy/components/grid/comparators/NaturalSortComparator';

const TceComparator = (valueA, valueB) => {
    if (!valueA?.length && !valueB?.length) {
        return 0;
    }

    if (!valueA?.length) {
        return -1;
    }

    if (!valueB?.length) {
        return 1;
    }

    const formattedA = valueA[0].tceValue?.rate;
    const formattedB = valueB[0].tceValue?.rate;

    return naturalSortComparator(formattedA, formattedB);
};

export const TceFilterComparator = (a, b) => {
    a = a || '';
    b = b || '';

    return naturalSortComparator(
        a.replace(/[,$€£]/g, ''),
        b.replace(/[,$€£]/g, '')
    );
};

export default TceComparator;
